module.exports = __webpack_public_path__ + "static/img/info-img-1.bcf6082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-img-1.png
// module id = 8TVc
// module chunks = 0